import React from 'react';

import { GeoJSON } from 'react-leaflet';

import { Polygon, MultiPolygon as MultiPolygonType } from '@typings/geo';

import { colors } from '@styles';

export type UniversalPolygonProps = {
  polygon: { _id: string | number } & (Polygon | MultiPolygonType);
};

export const UniversalPolygon = ({ polygon }: UniversalPolygonProps) => {
  return (
    <GeoJSON
      data={polygon}
      stroke
      color={colors.azure_radiance.hex()}
      key={polygon._id}
    />
  );
};
